import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';


@Component({
    selector: 'app-model-non-health-authority',
    templateUrl: './model-non-health-authority.component.html',
    styleUrls: ['./model-non-health-authority.component.scss'],
    standalone: false
})
export class ModelNonHealthAuthorityComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      trackingNumber: ['', { validators: [] }],
      batchNumber: ['', { validators: [] }],
      submissionChannelForm: this.fb.array([this.addSubmissionChannelForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get submissionChannelForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('submissionChannelForm');
  }

  addSubmissionChannelForm(): FormGroup {

    return this.fb.group({
      channel: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      trackingNumber: this.displayItemData('Company Model Tracking Number'),
      batchNumber: this.displayItemData('Company Model Batch Number')
    });

    this.deviceForm.setControl('submissionChannelForm', this.setSubmissionChannelForm());
  }

  setSubmissionChannelForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Applicable Submission Channel');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  channel: c[(this.getMapInnerPathName('Submission Channel'))[0]]
                })
            );
        });
    }

    return formArray;
  }


}
